import { useState } from "react";
import { C } from "../constants";
import { Sec, STitle, Btn } from "../components/Shared";

export default function Contact() {
  const [sent, setSent] = useState(false);
  return (
    <Sec>
      <STitle tag="Contact" title="Get in touch" sub="Have a question, partnership idea, or just want to say hello?" />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))", gap: 36, maxWidth: 860, margin: "0 auto" }}>
        <div>
          <h3 style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 700, fontSize: 17, color: C.text, marginBottom: 18 }}>Send us a message</h3>
          {sent ? (
            <div style={{ background: C.accentLight, borderRadius: 14, padding: 28, textAlign: "center" }}>
              <span style={{ fontSize: 36 }}>✅</span>
              <p style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 700, fontSize: 17, color: C.text, margin: "10px 0 4px" }}>Message sent!</p>
              <p style={{ fontFamily: "'Nunito', sans-serif", color: C.textMid, fontSize: 13.5 }}>We'll get back to you within 24 hours.</p>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              {[["Name", "text", "Your name"], ["Email", "email", "you@example.com"], ["Subject", "text", "What's this about?"]].map(([l, t, ph]) => (
                <div key={l}>
                  <label style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 600, fontSize: 13.5, color: C.text, display: "block", marginBottom: 5 }}>{l}</label>
                  <input type={t} placeholder={ph} style={{
                    width: "100%", padding: "11px 14px", borderRadius: 10, border: `1px solid ${C.border}`,
                    fontFamily: "'Nunito', sans-serif", fontSize: 14.5, outline: "none", boxSizing: "border-box"
                  }} />
                </div>
              ))}
              <div>
                <label style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 600, fontSize: 13.5, color: C.text, display: "block", marginBottom: 5 }}>Message</label>
                <textarea rows={5} placeholder="Tell us more..." style={{
                  width: "100%", padding: "11px 14px", borderRadius: 10, border: `1px solid ${C.border}`,
                  fontFamily: "'Nunito', sans-serif", fontSize: 14.5, outline: "none", resize: "vertical", boxSizing: "border-box"
                }} />
              </div>
              <Btn primary onClick={() => setSent(true)}>Send Message</Btn>
            </div>
          )}
        </div>
        <div>
          <h3 style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 700, fontSize: 17, color: C.text, marginBottom: 18 }}>Other ways to reach us</h3>
          {[
            ["📧", "Email", "hello@safezapp.com"],
            ["💬", "Support", "support@safezapp.com"],
            ["🏢", "Address", "Melbourne, Australia"],
          ].map(([ic, l, v], i) => (
            <div key={i} style={{
              display: "flex", gap: 14, alignItems: "center", marginBottom: 16,
              padding: 14, background: C.bg, borderRadius: 10
            }}>
              <div style={{
                width: 42, height: 42, borderRadius: 10, background: C.blueLight,
                display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0
              }}>{ic}</div>
              <div>
                <div style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 700, fontSize: 13.5, color: C.text }}>{l}</div>
                <div style={{ fontFamily: "'Nunito', sans-serif", fontSize: 13.5, color: C.textMid }}>{v}</div>
              </div>
            </div>
          ))}

          {/* App stores */}
          <div style={{ marginTop: 24 }}>
            <h3 style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 700, fontSize: 17, color: C.text, marginBottom: 12 }}>Download</h3>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              <a href="https://apps.apple.com/app/id6789908989" target="_blank" rel="noopener noreferrer" style={{
                display: "inline-flex", alignItems: "center", gap: 8,
                background: "#000", color: "#fff", borderRadius: 10,
                padding: "10px 20px", textDecoration: "none", fontSize: 14,
                fontFamily: "'Nunito', sans-serif", fontWeight: 600
              }}>
                <span style={{ fontSize: 20 }}>&#63743;</span>
                <span><span style={{ fontSize: 11, display: "block", opacity: 0.7 }}>Download on the</span>App Store</span>
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.dogmatech.safezapp" target="_blank" rel="noopener noreferrer" style={{
                display: "inline-flex", alignItems: "center", gap: 8,
                background: "#000", color: "#fff", borderRadius: 10,
                padding: "10px 20px", textDecoration: "none", fontSize: 14,
                fontFamily: "'Nunito', sans-serif", fontWeight: 600
              }}>
                <span style={{ fontSize: 20 }}>▶</span>
                <span><span style={{ fontSize: 11, display: "block", opacity: 0.7 }}>GET IT ON</span>Google Play</span>
              </a>
            </div>
            <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: 13, color: C.textLight, marginTop: 10 }}>
              Try it free for 30 days. No obligation.
            </p>
          </div>
        </div>
      </div>
    </Sec>
  );
}
